// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"31d6cfe0","452":"a28a19bc","484":"31d6cfe0","803":"516f621d","864":"84227cef","920":"31d6cfe0","968":"31d6cfe0","976":"31d6cfe0"}[chunkId] + ".chunk.css";
};